const AXES = ['group', 'template', 'categories', 'tags'];

export default function () {
    document.querySelectorAll('[data-list-filter]').forEach((panel) => {
        // fullPage.js sets its own z-index on <main> at runtime, which creates a stacking context
        // that traps any position:fixed element nested inside it below the offcanvas backdrop
        // (appended directly to <body>, same as this project's existing .modal markup already is).
        // Moving the panel to be a direct child of <body> escapes that context.
        document.body.appendChild(panel);

        const baseUrl = panel.dataset.filterBaseUrl;
        const checkboxes = Array.from(panel.querySelectorAll('[data-filter-axis]'));
        const applyButton = panel.querySelector('[data-filter-apply]');
        const resetButton = panel.querySelector('[data-filter-reset]');
        const applySpinner = applyButton.querySelector('.spinner-border');

        // A filter change is a real page load, so show that something is happening until the new page arrives.
        function setLoading(loading, source = applyButton) {
            panel.classList.toggle('is-loading', loading);
            applyButton.disabled = loading;
            resetButton.disabled = loading;
            applySpinner.classList.toggle('d-none', !(loading && source === applyButton));
            resetButton.classList.toggle('is-busy', loading && source === resetButton);
        }

        function go(url, source) {
            setLoading(true, source);
            window.location.href = url.toString();
        }

        // A group and its variants mirror each other: choosing the group ticks every variant, unticking a
        // single variant unticks the group and leaves the others, ticking all variants ticks the group.
        const variantsOf = (groupBox) => Array.from(
            panel.querySelectorAll(`[data-filter-children-of="${groupBox.value}"] [data-filter-axis="template"]`),
        );
        const syncGroup = (groupBox) => {
            const variants = variantsOf(groupBox);
            if (variants.length > 0) {
                groupBox.checked = variants.every((variant) => variant.checked);
            }
        };
        const groupBoxes = checkboxes.filter((cb) => cb.dataset.filterAxis === 'group');
        groupBoxes.forEach(syncGroup);

        applyButton.addEventListener('click', () => {
            const url = new URL(baseUrl, window.location.origin);
            // variants of a ticked group are covered by the group itself
            const covered = new Set(groupBoxes.filter((cb) => cb.checked).flatMap(variantsOf));

            AXES.forEach((axis) => {
                const values = checkboxes
                    .filter((cb) => cb.dataset.filterAxis === axis && cb.checked && !covered.has(cb))
                    .map((cb) => cb.value);
                if (values.length > 0) {
                    url.searchParams.set(axis, values.join(','));
                }
            });

            go(url, applyButton);
        });

        resetButton.addEventListener('click', () => go(new URL(baseUrl, window.location.origin), resetButton));

        checkboxes.forEach((cb) => cb.addEventListener('change', () => {
            if (cb.dataset.filterAxis === 'group') {
                variantsOf(cb).forEach((variant) => { variant.checked = cb.checked; });
            } else if (cb.dataset.filterAxis === 'template') {
                const groupBox = groupBoxes.find((box) => variantsOf(box).includes(cb));
                if (groupBox) {
                    syncGroup(groupBox);
                }
            }
            resetButton.hidden = !checkboxes.some((box) => box.checked);
        }));

        // coming back with the browser's back button restores the page from cache, loader included
        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                setLoading(false);
            }
        });
    });
}
